import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { encodeToByteArray1onwao0uakjfh as encodeToByteArray } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toString1h6jjoch8cjt8 as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function urlEncode(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = encodeToByteArray(_this__u8e3s4);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var b = element & 255;
    if (isUnreserved(b)) {
      this_0.o1(numberToChar(b));
    } else {
      this_0.m1(percentEncode(b));
    }
  }
  return this_0.toString();
}
function isUnreserved(_this__u8e3s4) {
  var tmp;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(97);
  var containsLower = Char__toInt_impl_vasixd(this_0);
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(122);
  if (_this__u8e3s4 <= Char__toInt_impl_vasixd(this_1)) {
    tmp_0 = containsLower <= _this__u8e3s4;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    var containsLower_0 = Char__toInt_impl_vasixd(this_2);
    var tmp_1;
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(90);
    if (_this__u8e3s4 <= Char__toInt_impl_vasixd(this_3)) {
      tmp_1 = containsLower_0 <= _this__u8e3s4;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var containsLower_1 = Char__toInt_impl_vasixd(this_4);
      var tmp_2;
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      if (_this__u8e3s4 <= Char__toInt_impl_vasixd(this_5)) {
        tmp_2 = containsLower_1 <= _this__u8e3s4;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp = true;
      } else {
        // Inline function 'kotlin.code' call
        var this_6 = _Char___init__impl__6a9atx(45);
        if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_6)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.code' call
          var this_7 = _Char___init__impl__6a9atx(46);
          if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_7)) {
            tmp = true;
          } else {
            // Inline function 'kotlin.code' call
            var this_8 = _Char___init__impl__6a9atx(95);
            if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_8)) {
              tmp = true;
            } else {
              // Inline function 'kotlin.code' call
              var this_9 = _Char___init__impl__6a9atx(126);
              if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_9)) {
                tmp = true;
              } else {
                tmp = false;
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function percentEncode(_this__u8e3s4) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var hex = toString(_this__u8e3s4, 16).toUpperCase();
  if (hex.length === 1) {
    hex = '0' + hex;
  }
  return '%' + hex;
}
//region block: exports
export {
  urlEncode as urlEncoded5v8jd8by0u4,
};
//endregion

//# sourceMappingURL=UrlEncode.mjs.map
